export default __webpack_public_path__ + "media/images/home/showreel-poster.png";